import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useT } from '../i18n';

export default function DialogConfirm(props) {
  const t = useT();
  const isDanger = props.danger === true;
  return (
    <>
      <Modal show={props.show} onHide={props.handleCancel}>
        <Modal.Header closeButton style={isDanger ? { background: '#cc2222', color: '#fff' } : {}}>
          <Modal.Title style={isDanger ? { color: '#fff' } : {}}>{props.title ?? t('resetTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isDanger && (
            <div style={{ color: '#cc2222', fontWeight: 'bold', marginBottom: '0.5rem', fontSize: '0.95em' }}>
              ⚠ {t('warningCannotBeUndone')}
            </div>
          )}
          {props.body ?? t('resetBody')}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{props.handleCancel()}}>
            {t('cancel')}
          </Button>
          {props.extraAction && (
            <Button variant={props.extraAction.variant ?? 'warning'} onClick={props.extraAction.onClick}>
              {props.extraAction.label}
            </Button>
          )}
          <Button variant={isDanger ? 'danger' : 'primary'} onClick={()=>{props.handleConfirm()}}>
              {props.confirmLabel ?? t('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}